import Vue from "vue";
// import App from "./App.vue";
// import router from "./router";
import { loadComponents } from "../Scripts/component-loader.js"; // that contains all loaders
import VueMeta from "vue-meta";
import Meta from "vue-meta";
// import "@/assets/scss/main.scss";

Vue.use(VueMeta);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-server-rendered",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true
});
Vue.config.productionTip = false;

loadComponents(); // run the function we imported in the top to load all of our vue apps we created depends on the current vue, retrive the current app(that e select to lunch our instance from)

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount("#app");